import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { motion } from 'framer-motion'
import HomePage from './pages/HomePage'
import PlayerPage from './pages/PlayerPage'
import FavoritesPage from './pages/FavoritesPage'
import CallbackPage from './pages/CallbackPage'
import { MusicProvider } from './contexts/MusicContext'

function App() {
  return (
    <MusicProvider>
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-pink-50">
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="container mx-auto px-4 py-8"
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/player" element={<PlayerPage />} />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/callback" element={<CallbackPage />} />
          </Routes>
        </motion.div>
      </div>
    </MusicProvider>
  )
}

export default App
